import { Messages, WishlistBrandListItem } from '../../../@types/wishlist.js';
import { brandService } from '../../../scripts/service/brand-service.js';
import { pushToSnackbar } from '../../../scripts/service/snackbar-service.js';

const PLACEMENT = 'wishlist_brands_tab';

export function formatBrandUnfollowedSnackbar(messages: Messages, brandName: string): string {
  const template = messages['ents_wishlist_brands_unfollowed_snackbar'] ?? '{0}';
  return template.replace('{0}', brandName);
}

export function formatBrandUnfollowedAriaLabel(messages: Messages, brandName: string): string {
  const template = messages['ents_wishlist_brands_unfollowed_aria_label'] ?? '{0}';
  return template.replace('{0}', brandName);
}

/**
 * Unfollows a brand: optimistically removes it via {@link brandService} (DELETE + tracking +
 * REMOVED_BRAND_EVENT, which the brands list reacts to by hiding the tile) and shows a snackbar with
 * an Undo action that re-follows the brand.
 */
export function unfollowBrand(messages: Messages, brand: WishlistBrandListItem): void {
  void brandService.removeBrand({
    brandCode: brand.code,
    brandName: brand.name,
    tracking: { placement: PLACEMENT, context: 'remove_heart', addDate: brand.createdAt },
  });

  void pushToSnackbar(
    formatBrandUnfollowedSnackbar(messages, brand.name),
    undefined,
    messages['ents_wishlist_delete_buttontext'],
    () => {
      void brandService.addBrand(
        {
          brandCode: brand.code,
          brandName: brand.name,
          tracking: { placement: PLACEMENT, context: 'add_heart' },
        },
        { silent: true },
      );
    },
  );
}
